import { ArrowLeftIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

import { ReactComponent as Logo } from "../../assets/logo.svg";
import { ROUTES } from "../../utils/constants";

export default function HeaderLogoNav() {
  const location = useLocation();
  const { t } = useTranslation();

  const ProfileNav = () => (
    <div className="flex items-center gap-2">
      <Link to={ROUTES.HOME} className="flex items-center cursor-pointer">
        <ArrowLeftIcon />
      </Link>
      {t("menu.myProfile")}
    </div>
  );

  const ChangePasswordNav = () => (
    <div className="flex items-center gap-2">
      <Link to={ROUTES.PROFILE} className="flex items-center cursor-pointer">
        <ArrowLeftIcon />
      </Link>
      {t("menu.changePassword")}
    </div>
  );

  const SessionViewNav = () => <div className="flex items-center gap-2">{t("menu.session")}</div>;

  const NewSessionNav = () => <div className="flex items-center gap-2">{t("menu.session")}</div>;

  const routeContent: Record<string, React.ReactNode> = {
    [ROUTES.PROFILE]: <ProfileNav />,
    [ROUTES.PROFILE_CHANGE_PASSWORD]: <ChangePasswordNav />,
    [ROUTES.SESSION]: <NewSessionNav />,
  };

  // Handle dynamic /session/:id route
  const isSessionView = /^\/session\/[^/]+$/.test(location.pathname);
  const dynamicRouteContent = isSessionView ? <SessionViewNav /> : null;

  return (
    <div>
      {routeContent[location.pathname] ?? dynamicRouteContent ?? (
        <Link to={ROUTES.HOME}>
          <Logo className="fill-general-gray-800" />
        </Link>
      )}
    </div>
  );
}
